<template>
  <div class="platform-main">
    <el-checkbox v-model="queryParams.openNotice" true-label = "1" false-label = "0">充值余额预警通知</el-checkbox>
    <div class="wx-tongzhi">
      <span>账户余额低于</span>
      <el-input v-model="queryParams.amount" placeholder="请输入预警金额"></el-input>
      <span>元时，发送短信到：{{queryParams.phone}}</span>
    </div>
    <p class="explain">说明：您可以在"账户中心" > "修改基本信息" 处更改您的手机号码。</p>
    <el-button type="primary" @click="saveInfo()">提交数据</el-button>
  </div>
</template>
<script>
import { assetNotice } from "@/api/api.js";
import { getAssetNotice } from "@/api/api.js";
export default {
  data() {
    return{
      userId:'',
      queryParams:{
        openNotice:"1"
      }
    }
  },
  watch:{
    'queryParams.checked'(newVal,oldVal){
      
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        userId : this.userId
      }
      getAssetNotice(params).then(res=>{
        this.queryParams = res.data.data
      })
    },
    saveInfo(){
      let params ={
        ...this.queryParams,
        userId : this.userId
      }
      assetNotice(params).then(res=>{
        this.$notify({
            title: '成功',
            message: '信息提交成功',
            type: 'success'
          });
      })
    }
  },
  created() {
    this.userId = this.$route.params && this.$route.params.userId;
  },
  mounted() {

  },
};
</script>

<style scoped lang="less">
  .platform-main{
    color: #606266;
  }
  .wx-tongzhi{
    font-size: 14px;
    margin: 20px 0;
    /deep/ .el-input{
      width: 180px;
      margin: 0 10px;
    }
  }
  .explain{
    font-size: 14px;
  }
  .el-button{
    margin: 30px 0;
  }
</style>


